// extracted by mini-css-extract-plugin
module.exports = {"container":"CaseStudy-module--container--1gX34","FullWidthImage":"CaseStudy-module--FullWidthImage--_-BRa","caseStudyIntro":"CaseStudy-module--caseStudyIntro--2WqnT"};